export default "__VITE_ASSET__Bpo14uet__"